// Font Awesome runtime for HTML consumers (dist/font-awesome.js) - a 1:1 port
// of v1 app/scripts/font-awesome.js, served as its own script exactly like
// v1's dist/scripts/font-awesome.js. Storybook runs the same two calls inline
// in .storybook/preview.js.
//
// Registers the curated Kit subset (the same kit @martinus/styles generates
// its icons catalogue from, so list_icons and this bundle can't drift) and
// lets dom.watch() replace <i class="far fa-..."> markup with inline SVGs.
// It also injects the FA utility CSS (fa-xl, fa-spin, ...) - without this
// script, icon markup renders as empty elements.
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { all } from '@awesome.me/kit-c68fa87f81/icons';

library.add(...all);
dom.watch();
